import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Button, Input } from "semantic-ui-react";
import { fetchSearchData, saveSearchDataParams } from "../../actions/searchDataAction";
import { configure_progress, ContactUs, showContactUsPopup, toggleGetStarted } from "../../actions/globalAction";
import "./HomePage.scss";
import SearchTipModal from "./SearchTipModal";
import GettingStartedModal from "./GettingStartedModal";
import NavbarContainer from "../Navbar/NavbarContainer";
import { ReactComponent as SearchIcon } from "../../assets/svg/search.svg";
import Tour from "./TourFiles/Tour_home.js";
// import UpgradeWrapper from "../AppContainer/UpgradeToPremium/UpgradeButton";
import { setActiveModule } from "../../actions/sideBarActions";
// import InsightsTabContainer from "./InsightsTab/InsightsTabContainer";
// import { minimizeInsightsTab } from "../../actions/insightsRecommendationActions";

class HomePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchTipModalOpen: false,
            search_term: "",
        };
    }

    componentDidMount() {
        localStorage.removeItem("activeModule");
        // this.props.replaceModule(null);
        sessionStorage.removeItem("custom_query");

        const gettingStarted = sessionStorage.getItem("getStarted");

        if (gettingStarted) this.props.toggleGetStarted(true);
        // setTimeout(() => {
        //     this.props.minimizeInsightsTab(false);
        // }, 1000);

        // zE("webWidget", "updateSettings", { color: { theme: "#268af6" } });
        // zE("webWidget", "show");
    }

    // componentWillUnmount() {
    //     zE("webWidget", "hide");
    // }

    handleSearchChange(e) {
        this.setState({ search_term: e.target.value });
    }

    showContactUsPopup(val) {
        this.props.showContactUsPopup(val);
    }

    showSearchTipPopup(val) {
        this.setState({
            searchTipModalOpen: val,
        });
    }

    onFormSubmit(e) {
        e.preventDefault();
        let custom_query = this.state.search_term;
        if (custom_query.trim().length) {
            if (custom_query && custom_query.length) {
                sessionStorage.setItem("custom_query", custom_query);
            } else {
                sessionStorage.removeItem("custom_query");
                return false;
            }
            this.props.configure_progress("explore_search", 11);
            localStorage.setItem("activeModule", "Listening");
            this.props.replaceModule("Listening");
            this.props.history.push("/search");
        } else {
            return false;
        }
    }

    resetForm() {
        this.setState({ search_term: "" });
    }

    contactUs(data) {
        this.props.ContactUs(data);
    }

    render() {
        let isTrialPackage = this.props.isFreeTrial?.package_code === "free";
        return (
            <div className="Home_section">
                <NavbarContainer history={this.props.history} location={this.props.location} tourComponent={Tour} />
                {/* {isTrialPackage && (
                    <div className="upgrade__menu">
                        <UpgradeWrapper />
                    </div>
                )} */}
                <div className={`HomeSearchSection tour-start1  add__margin `}>
                    <div className="homeMessage">
                        <p>{this.props?.agencyLogo ? "Drive results for your business" : "Radarr drives results for your business."}</p>
                        <p>Get started by running a search below for any keyword.</p>
                    </div>
                    <form className="searchbox_div home_step1" onSubmit={(e) => this.onFormSubmit(e)}>
                        <Input
                            value={this.state.search_term || ""}
                            onChange={(e) => {
                                this.handleSearchChange(e);
                            }}
                            className="Homesearch"
                            placeholder="Enter your search terms here"
                        />
                        <div className="search-button" onClick={(e) => this.onFormSubmit(e)}>
                            <SearchIcon />
                        </div>
                    </form>
                    <div className="searchtip_div">
                        <p
                            onClick={() => this.showSearchTipPopup(true)}
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Click for Query tips!"
                            className="home_step2">
                            Help me write a search query!
                        </p>
                    </div>
                </div>
                <SearchTipModal open={this.state.searchTipModalOpen} hideModal={() => this.showSearchTipPopup(false)} />
                <GettingStartedModal />
                {/* {[10202, 10262].includes(this.props.companyLteId) ? (
                    <>
                        <InsightsTabContainer closeInsights={this.handleinsightsToggle} isOpen={this.state.insightsTab} />
                    </>
                ) : null} */}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isFreeTrial: state.globalReducer?.packageObj,
        contactUsModalOpen: state.globalReducer.show_contactus,
        themeMode: state.globalReducer.themeMode,
        contactUs_loader: state.globalReducer.contactUs_loader,
        sortOption: state.refineFilterReducer.filterSortValue,
        sentiment: state.refineFilterReducer.sentiment,
        exclusion: state.refineFilterReducer.exclusion,
        sentimentType: state.refineFilterReducer.sentimentType,
        media: state.refineFilterReducer.media,
        channel: state.refineFilterReducer.channel,
        // grouping: state.refineFilterReducer.grouping,
        postType: state.refineFilterReducer.postType,
        sampling: state.refineFilterReducer.sampling,
        showBulkOptions: state.refineFilterReducer.showBulkOptions,
        original_all_filter: state.globalReducer.original_all_filter,
        // original_all_filter_id: state.globalReducer.original_all_filter_id,
        filterOptions: state.globalReducer.filterOptions,
        agencyLogo: state.globalReducer.company?.whitelabel_logo,
        companyLteId: state.globalReducer.company?.lite_company_id,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchSearchData: (data, searchDataType) => {
            dispatch(fetchSearchData(data, searchDataType));
        },
        saveSearchDataParams: (searchDataType, custom_query) => {
            dispatch(saveSearchDataParams(searchDataType, custom_query));
        },
        ContactUs: (d) => {
            dispatch(ContactUs(d));
        },
        showContactUsPopup: (v) => {
            dispatch(showContactUsPopup(v));
        },
        toggleGetStarted: (data) => dispatch(toggleGetStarted(data)),
        replaceModule: (data) => dispatch(setActiveModule(data)),
        configure_progress: (field, total) => dispatch(configure_progress(field, total)),
        // minimizeInsightsTab: (bool) => dispatch(minimizeInsightsTab(bool)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
